import {z as r} from 'zod';

import {ReviewsAnalysisModeEnum} from '../reivew-analysis-const';
import {ReviewRateEnum} from '../review-rate/review-rate-type';
import {SentimentEnum} from '../review-sentiment/review-sentiment-type';

export enum Alpha2Enum {
    Armenia = 'am',
    Austria = 'at',
    Belarus = 'by',
    Bulgaria = 'bg',
    Estonia = 'ee',
    Kazakhstan = 'kz',
    Latvia = 'lv',
    Lithuania = 'lt',
    Lebanon = 'lb',
    Moldova = 'md',
    Poland = 'pl',
    Romania = 'ro',
    Russia = 'ru',
    Serbia = 'rs',
    Ukraine = 'ua',
    'United-Arab-Emirates' = 'ae',
    Uzbekistan = 'uz',
    Thailand = 'th',
    Azerbaijan = 'az',
    'United-States-of-America' = 'us',
    Georgia = 'ge',
    Mexico = 'mx',
    Chile = 'cl',
    Panama = 'pa',
    Kyrgyzstan = 'kg',
    Albania = 'al',
    Peru = 'pe',
    Germany = 'de',
    Spain = 'es',
    Slovenia = 'si',
    'Saudi-Arabia' = 'sa',
    Hungary = 'hu',
    Greece = 'gr',
    Turkey = 'tr',
    Tunisia = 'tn',
    Croatia = 'hr',
    Slovakia = 'sk',
    Oman = 'om',
    Qatar = 'qa',
    Guatemala = 'gt',
    Belgium = 'be',
    Bolivia = 'bo',
    'Costa-Rica' = 'cr',
    Portugal = 'pt',
    'Bosnia-Herzegovina' = 'ba',
    Cyprus = 'cy',
    Nicaragua = 'ni',
    // eslint-disable-next-line unicorn/prevent-abbreviations
    'el-salvador' = 'sv',
    France = 'fr',
    Switzerland = 'ch',
    Argentina = 'ar',
    Honduras = 'hn',
    Iraq = 'iq',
    Montenegro = 'me',
    Morocco = 'ma',
    India = 'in',
    Netherlands = 'nl',
    Egypt = 'eg',
    Brazil = 'br',
    Tajikistan = 'tj',
    'South-Korea' = 'kr',
    'Dominican-Republic' = 'do',
    Malaysia = 'my',
    Uruguay = 'uy',
    Colombia = 'co',
    Israel = 'il',
    Bahrain = 'bh',
    Australia = 'au',
    Cameroon = 'cm',
    Canada = 'ca',
    China = 'cn',
    'Czech-Republic' = 'cz',
    Ethiopia = 'et',
    Finland = 'fi',
    Indonesia = 'id',
    Kenya = 'ke',
    Macedonia = 'mk',
    Singapore = 'sg',
    'South-Africa' = 'za',
    Sweden = 'se',
    Vietnam = 'vn',
    Kuwait = 'kw',
    Jordan = 'jo',
    Italy = 'it',
    Gabon = 'ga',
    Bangladesh = 'bd',
    Ecuador = 'ec',
}

const reviewRegionSchema = r.object({
    code: r.string(),
    name: r.string(),
    value: r.number(),
    sentiment: r.number(),
});

export type ReviewRegionType = r.infer<typeof reviewRegionSchema>;

const reviewCountrySchema = r.object({
    alpha2: r.nativeEnum(Alpha2Enum),
    name: r.string(),
    total: r.number(),
    regions: r.array(reviewRegionSchema),
});

export type ReviewCountryType = r.infer<typeof reviewCountrySchema>;

export const reviewRegionsResponseSchema = r.array(reviewCountrySchema);

export type ReviewsAnalysisRegionsQueryType = {
    mode?: ReviewsAnalysisModeEnum;
    brandIds?: Array<number>;
    companyIds?: Array<number>;
    startDate: string | null;
    endDate: string | null;
    sentiments: Array<SentimentEnum>;
    sources: Array<number>;
    tags: Array<string>;
    phrases: Array<string>;
    topics: Array<string>;
    userTagsIds: Array<number>;
    aspectIds: Array<number>;
    rating: Array<ReviewRateEnum>;
    withAnswers: boolean | null;
    withText: boolean | null;
    ableToReply: boolean | null;
    target: string | null;
    useDeleted: boolean | null;
};
